import React  from 'react';
import { Button, Row, Col, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import FilterBox from './FilterBox';
import SearchBox from '../../../components/Filter/index';
import Section from './Section';


function CellsTab({
  section,
  boxes,
  getBoxes,
  postSection,
  getSection,
  storage,
  deleteSection,
  updateSection,
  locks,
  postBox,
  getDevices,
  updateDevice,
  updateBox,
  getUsers,
  users,
  loadingDevice,
  socket,
  updateUsers
}) {
  const { t } = useTranslation();
  let name = '';
  const handleChange = (e) => {
    name = e.target.value;
  };

  const handleSection = () => {
    if (name !== '') {
      postSection(
        {
          name: name,
          warehouse_id: storage.id,
        },
        {
          sync: true,
          query: {
            warehouse_id: storage.id,
          },
        },
      );
    }
  };

  const editSection = (value, id) => {
    updateSection(
      {
        name: value,
        warehouse_id: storage.id,
        id,
      },
      {
        sync: true,
        query: {
          warehouse_id: storage.id,
        },
      },
    );
  };


  return (
    <div className="pb-15 bt-15">
      <div className="pb-30">
        <Row gutter={[16, 16]} type="flex">
          <Col span={5}>
            {' '}
            <FilterBox
              storageId={storage ? storage.id : null}
              getBoxes={getBoxes}
              socket={socket}
            />
          </Col>
          <Col span={19}>
            <SearchBox
              uniqId="boxes"
              dataSource={boxes}
              placeholder={t('searchPlaceholderPage')}
              updateData={getBoxes}
            />
          </Col>
        </Row>
      </div>
      {storage ? (
        <Section
          deleteSection={deleteSection}
          update={editSection}
          boxes={boxes}
          section={section}
          locks={locks}
          postBox={postBox}
          getSection={getSection}
          storageId={storage.id}
          getBoxes={getBoxes}
          getDevices={getDevices}
          updateDevice={updateDevice}
          updateBox={updateBox}
          users={users}
          getUsers={getUsers}
          loadingDevice={loadingDevice}
          updateUsers={updateUsers}
        />
      ) : null}
      <div className="pb-15 bt-15 flex">
        <div className="text-black flex items-center font-medium">
          {t('section')}
        </div>
        <div>
          <Input
            onChange={handleChange}
            className="bg-ghost rounded-xs ml-10"
            placeholder={t('inputNameSection')}
          />
        </div>
      </div>
      <Button
        onClick={() => {
          handleSection();
        }}
        className="pl-16 pr-27 flex w-179 mt-20 items-center justify-between"
        type="primary"
      >
        <PlusOutlined />
        {t('createSection')}
      </Button>
    </div>
  );
}

CellsTab.propTypes = {};

export default CellsTab;
